import { render } from "./ClientRelativeFormBlock.vue?vue&type=template&id=3d826fe6"
import script from "./ClientRelativeFormBlock.vue?vue&type=script&lang=js"
export * from "./ClientRelativeFormBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__